import { RepFieldAudit, SortTypeEnum } from "@repo/models";
import { Column, GridBaseProps, GridPreLoaded, OriginalTimezoneDateColumn } from "@repo/ui";

import { useRepFieldAuditQueries } from "../../../api/repFieldAuditApi";

function passFormatter(audit: RepFieldAudit) {
	if (!audit.showScore) return "";

	return audit.pass ? "Pass" : "Fail";
}

const columns = [
	new Column("Form Type", "formTypeName"),
	new Column("Audit Type", "auditTypeName"),
	new Column("QA Analyst", "qaAnalyst"),
	new OriginalTimezoneDateColumn("Audit Date", "auditDate").dateOnly().withSortBy(SortTypeEnum.descending),
	new Column("Pass").withFormat(passFormatter),
	new Column("Comments", "comments"),
] as Column<RepFieldAudit>[];

export default function FieldAuditGridBasic(props: GridBaseProps<RepFieldAudit>) {
	const { useRepFieldAuditQuery } = useRepFieldAuditQueries();
	const { data, loaded, clearQuery } = useRepFieldAuditQuery();

	return (
		<GridPreLoaded<RepFieldAudit>
			{...props}
			title="Field Audits"
			columns={columns}
			values={data?.data ?? []}
			loading={!loaded}
			getData={clearQuery}
		/>
	);
}
